export default "__VITE_ASSET__CMBvapFG__"